import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListResultDtoOfLookupDtoOfGuid } from '@unistocks/proxy/axios-client';
import { difference } from '@unistocks/shared/utils/util';

export type WatchlistSlice = {
  selectedWatchlistId?: string;
  watchlists: {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    [key: string]: {};
  };
};

const initialState: WatchlistSlice = {
  selectedWatchlistId: undefined,
  watchlists: {}
};

const { reducer, actions, selectors, reducerPath } = createSlice({
  name: 'watchlist',
  reducerPath: 'watchlist',
  initialState,
  reducers: {
    syncWatchlistState: (state, action: PayloadAction<ListResultDtoOfLookupDtoOfGuid>) => {
      const { items } = action.payload;
      const portfolioIds = items.map(({ id }) => id);
      const deletedIds = difference(Object.keys(state.watchlists), portfolioIds);

      for (const id of portfolioIds) {
        if (!state.watchlists[id]) {
          state.watchlists[id] = {};
        }
      }

      for (const id of deletedIds) {
        delete state.watchlists[id];
      }
    },

    setSelectedWatchlistId: (state, action: PayloadAction<string | undefined>) => {
      state.selectedWatchlistId = action.payload;
    },

    clear: () => ({ ...initialState })
  },
  selectors: {
    selectSelectedWatchlistId: state => state.selectedWatchlistId
  }
});

export const WatchlistReducer = reducer;
export const WatchlistActions = actions;
export const WatchlistReducerPath = reducerPath;
export const { selectSelectedWatchlistId } = selectors;
